'use strict';
module.exports = require('../../full/instance/index-of');



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/features/instance/index-of.js
// module id = 596
// module chunks = 13